import { LOGOUT } from "@/components/access/ducks/Actions"
import {
  DELETE_ROLE,
  RECEIVE_CONSTITUENT_ROLES,
  RECEIVE_DELETE_ROLE_ERROR,
  RECEIVE_NEW_USERS,
  RECEIVE_ROLES,
  RECEIVE_USERS,
  SET_SHOW_ADMIN_VIEW,
} from "@/components/permissions/admin/ducks/Actions"

const defaultState = {
  roles: [],
  constituentRoles: [],
  newUsersLoading: false,
  users: [],
  showAdminView: true,
  nextUsersPage: 0,
  usersPage: 0,
}

const adminPermissionsReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case SET_SHOW_ADMIN_VIEW:
      return {
        ...oldState,
        showAdminView: action.showAdminView,
      }

    case RECEIVE_ROLES:
      return {
        ...oldState,
        roles: action.roles,
      }

    case RECEIVE_CONSTITUENT_ROLES:
      return {
        ...oldState,
        constituentRoles: action.constituentRoles,
      }

    case RECEIVE_USERS:
      return {
        ...oldState,
        users:
          action.resp.usersPage === 0
            ? action.resp.users
            : oldState.users.concat(action.resp.users),
        usersPage: action.resp.usersPage,
      }

    case DELETE_ROLE:
      return {
        ...oldState,
        newUsersLoading: true,
      }

    case RECEIVE_DELETE_ROLE_ERROR:
      return {
        ...oldState,
        newUsersLoading: false,
      }

    case RECEIVE_NEW_USERS: {
      const newUsers = oldState.users

      action.resp.newUsers.forEach((element, i) => {
        const index = newUsers.findIndex((p) => p[7] === action.resp.newUsers[i][7])
        newUsers[index] = element
      })

      return {
        ...oldState,
        users: newUsers,
        newUsersLoading: false,
      }
    }

    case LOGOUT:
      return defaultState

    default:
      return oldState
  }
}

export default adminPermissionsReducer
